import { render, staticRenderFns } from "./PerStudio.vue?vue&type=template&id=7643d31c&scoped=true&"
import script from "./PerStudio.vue?vue&type=script&lang=js&"
export * from "./PerStudio.vue?vue&type=script&lang=js&"
import style0 from "./PerStudio.vue?vue&type=style&index=0&id=7643d31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643d31c",
  null
  
)

export default component.exports